import { iUidService, iUidGenerator } from './uid.types';

export class UidService implements iUidService {
  private uidGenerator: iUidGenerator;

  constructor(uidGenerator: iUidGenerator) {
    this.uidGenerator = uidGenerator;
  }

  generateV4(): string {
    return this.uidGenerator.v4();
  }
}
